// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__wCVXk","topBottomGutter":"Layout_topBottomGutter__1uxhA"};